import React from 'react'
import ReactDOM from 'react-dom'
import { Components } from '@src/containers/PartnersModalSuccess'

const formContainer = document.getElementById('partners-modal-success')

if (formContainer) {
  ReactDOM.render(<Components.PartnersModalSuccess />, formContainer)
}
